var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.multiline)?_c('textarea',_vm._b({ref:"inputRef",class:[_vm.$style.root, _vm.$style.textarea],style:({ width: _vm.width }),domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)},"keypress":_vm.handleKeyPress}},'textarea',_vm.$props,false)):_c('input',_vm._b({ref:"inputRef",class:[
    _vm.$style.root,
    ( _obj = {}, _obj[_vm.$style.compact] = _vm.compact, _obj )
  ],style:({ width: _vm.width }),domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)},"keypress":_vm.handleKeyPress}},'input',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }